import { ReactElement } from 'react'
import Order from '../components/Order'
import Layout from '../components/layout'

const OrderPage = (): ReactElement => {
  return (
    <Layout >
      <Order />
    </Layout>
  )
}

export default OrderPage
